import packageJson from '../../package.json';

export function VersionDisplay() {
	return (
		<div
			className='fixed top-[0px] right-[0px] text-[6px] px-[1px] py-0 rounded opacity-30 z-[99999999]'
			style={{ color: 'hsl(var(--muted-foreground))' }}>
			v{packageJson.version}
		</div>
	);
}
